import { createBrowserRouter } from "react-router-dom";
import AuthPage from "../pages/Auth";
import { ToastProvider } from "../hooks/useToast";
import { SessionProvider } from "../hooks/useSession";
import HomePage from "../pages/Home";
import AvaliacaoPage from "../pages/Avaliacao";
import { StoryblokProvider } from "../hooks/useStoryblok";
import NewAvaliacao from "../pages/NewAvaliacao";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ptBR } from "@mui/x-date-pickers/locales";
import "dayjs/locale/pt-br";
import PreferenciasPage from "../pages/Preferencias";
import MinhasAvaliacoesPage from "../pages/MinhasAvaliacoes";
import { CollectionsProvider } from "../hooks/useCollectionList";
import ProtectedRoute from "./protected-route";
import ResetPasswordPage from "../pages/ResetPassword";
import RequestPasswordResetPage from "../pages/RequestPasswordReset";
export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <SessionProvider>
        <ToastProvider>
          <AuthPage />
        </ToastProvider>
      </SessionProvider>
    ),
  },
  {
    path: "/password-reset",
    element: (
      <ToastProvider>
        <ResetPasswordPage />
      </ToastProvider>
    ),
  },
  {
    path: "/password-reset/request",
    element: (
      <ToastProvider>
        <RequestPasswordResetPage />
      </ToastProvider>
    ),
  },
  {
    path: "/home",
    element: (
      <SessionProvider>
        <ProtectedRoute>
          <ToastProvider>
            <CollectionsProvider>
              <HomePage />
            </CollectionsProvider>
          </ToastProvider>
        </ProtectedRoute>
      </SessionProvider>
    ),
  },
  {
    path: "/creditos",
    element: (
      <SessionProvider>
        <ProtectedRoute>
          <ToastProvider>
            <PreferenciasPage />
          </ToastProvider>
        </ProtectedRoute>
      </SessionProvider>
    ),
  },
  {
    path: "/avaliacoes",
    element: (
      <SessionProvider>
        <ProtectedRoute>
          <StoryblokProvider>
            <ToastProvider>
              <CollectionsProvider>
                <MinhasAvaliacoesPage />
              </CollectionsProvider>
            </ToastProvider>
          </StoryblokProvider>
        </ProtectedRoute>
      </SessionProvider>
    ),
  },
  {
    path: "/avaliacoes/:id",
    element: (
      <SessionProvider>
        <ProtectedRoute>
          <StoryblokProvider>
            <ToastProvider>
              <AvaliacaoPage />
            </ToastProvider>
          </StoryblokProvider>
        </ProtectedRoute>
      </SessionProvider>
    ),
  },
  {
    path: "/avaliacoes/criar",
    element: (
      <SessionProvider>
        <ProtectedRoute>
          <StoryblokProvider>
            <ToastProvider>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="pt-br"
                localeText={
                  ptBR.components.MuiLocalizationProvider.defaultProps
                    .localeText
                }
              >
                <NewAvaliacao />
              </LocalizationProvider>
            </ToastProvider>
          </StoryblokProvider>
        </ProtectedRoute>
      </SessionProvider>
    ),
  },
  {
    path: "/avaliacoes/:id/editar",
    element: (
      <SessionProvider>
        <ProtectedRoute>
          <StoryblokProvider>
            <ToastProvider>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="pt-br"
                localeText={
                  ptBR.components.MuiLocalizationProvider.defaultProps
                    .localeText
                }
              >
                <NewAvaliacao />
              </LocalizationProvider>
            </ToastProvider>
          </StoryblokProvider>
        </ProtectedRoute>
      </SessionProvider>
    ),
  },
]);
